import { getComparePublishedSchedule } from "../controller/get-compare-published-schedule"
import { dummySchedule } from "routes/schedule/lib/useSchedule"

export function useCompareSchedule(code, version = "no_v", enabled = true) {
    const schedule = getComparePublishedSchedule.useResultsOnce(enabled ? code : undefined, version) ?? dummySchedule

    if (!enabled) {
        return {
            loading: false,
            schedule: null,
        }
    }

    return {
        loading: schedule === dummySchedule,
        schedule,
    }
}
